import { render, staticRenderFns } from "./tableSwitch.vue?vue&type=template&id=de26edb0&scoped=true&"
import script from "./tableSwitch.vue?vue&type=script&lang=js&"
export * from "./tableSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de26edb0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2026/Temperature/TempAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de26edb0')) {
      api.createRecord('de26edb0', component.options)
    } else {
      api.reload('de26edb0', component.options)
    }
    module.hot.accept("./tableSwitch.vue?vue&type=template&id=de26edb0&scoped=true&", function () {
      api.rerender('de26edb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/rw/tempTable/components/tableSwitch.vue"
export default component.exports